<template>
  <v-card color="background" variant="elevated" elevation="4" rounded="lg" class="pa-6 mb-4">
    <div class="d-flex align-start ga-3 mb-4">
      <v-avatar v-if="n != null" color="primary" variant="tonal" size="28" rounded="lg">
        <span class="text-subtitle-2 font-weight-bold">{{ n }}</span>
      </v-avatar>
      <div class="flex-grow-1">
        <h3 class="text-h6 font-weight-bold">{{ title }}</h3>
        <p v-if="hint" class="text-body-2 text-medium-emphasis mt-1 mb-0">{{ hint }}</p>
      </div>
    </div>
    <div :class="n != null ? 'pl-10' : ''">
      <slot />
    </div>
  </v-card>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'

@Options({
  props: {
    n: { type: [Number, String], default: null },
    title: { type: String, required: true },
    hint: { type: String, default: '' }
  }
})
export default class EditorBlock extends Vue {
  n!: number | string | null
  title!: string
  hint!: string
}
</script>
